import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type StateProvince = IdValue;

export const getStateProvinces = createEndpoint<StateProvince[]>(({ fetch }) => (countryId) => fetch(`/Configuration/GetStateProvinces/${countryId}`));